module.exports = __webpack_public_path__ + "static/img/miomas.a576b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miomas.png
// module id = qclK
// module chunks = 1